import { isEmpty } from 'lodash';
import queryString from 'qs';

const getCustomerGroupRequest = ({ groupType, custGroup }) => {
    const payload = {
        name: groupType,
        search: !isEmpty(custGroup) ? custGroup : null,
        page: 1,
        limit: 10,
    };

    return `?${queryString.stringify(payload, { skipNulls: true, arrayFormat: 'comma' })}`;
};

export default getCustomerGroupRequest;
